module.exports = __webpack_public_path__ + "static/media/IMG_20201031_0017.4e0ce8e5.jpg";